export const CircleX = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.4993 7.49984L7.49935 12.4998M12.4993 12.4998L7.49935 7.49984M17.7077 9.99984C17.7077 14.257 14.2565 17.7082 9.99935 17.7082C5.74215 17.7082 2.29102 14.257 2.29102 9.99984C2.29102 5.74264 5.74215 2.2915 9.99935 2.2915C14.2565 2.2915 17.7077 5.74264 17.7077 9.99984Z"
      stroke="#D71313"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export default CircleX
